.jz-docm {
  --bg: #fdf3ec;
  --card: #fff;
  --ink: #2a1e18;
  --mute: #85746a;
  --line: #f0e1d6;
  --acc: #e8643a;
  --acc2: #fbe1d4;
  --ok: #1f9d63;
  --okbg: #e2f5ec;
  --warn: #b7791f;
  --warnbg: #fdf0d5;
  --bad: #c53b3b;
  --badbg: #fbe3e3;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 80;
  color: var(--ink);
  font-size: 14px;
  line-height: 1.5;
}

.jz-docm .box {
  position: relative;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 24px;
  width: 100%;
  max-width: 480px;
  max-height: 92vh;
  overflow: auto;
  box-shadow: 0 20px 60px rgba(42, 30, 24, 0.25);
}

.jz-docm .box.wide {
  max-width: 920px;
}

.jz-docm .x {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: var(--bg);
  color: var(--mute);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.jz-docm h2 {
  font-size: 18px;
  margin: 0 0 4px;
}

.jz-docm .sub {
  color: var(--mute);
  margin: 0 0 16px;
}

.jz-docm .btn {
  border: 0;
  background: var(--acc);
  color: #fff;
  padding: 10px 16px;
  border-radius: 10px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.jz-docm .btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.jz-docm .btn.g {
  background: var(--acc2);
  color: var(--acc);
}

.jz-docm .btn.o {
  background: none;
  border: 1px solid var(--line);
  color: var(--ink);
}

.jz-docm .btns {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 18px;
}

.jz-docm .btns.end {
  justify-content: flex-end;
}

.jz-docm .foot {
  color: var(--mute);
  font-size: 12px;
  margin-top: 14px;
}

.jz-docm .mono {
  font-variant-numeric: tabular-nums;
}

/* Receipt */
.jz-docm .rc {
  text-align: center;
}

.jz-docm .tick {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--okbg);
  color: var(--ok);
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
}

.jz-docm .tick.warn {
  background: var(--warnbg);
  color: var(--warn);
}

.jz-docm .tick.bad {
  background: var(--badbg);
  color: var(--bad);
}

.jz-docm .head-ok {
  color: var(--ok);
  font-weight: 700;
}

.jz-docm .head-warn {
  color: var(--warn);
  font-weight: 700;
}

.jz-docm .head-bad {
  color: var(--bad);
  font-weight: 700;
}

.jz-docm .amt {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: -1px;
  margin: 4px 0;
}

.jz-docm .when {
  color: var(--mute);
  margin-bottom: 14px;
}

.jz-docm .kv {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  border-top: 1px dashed var(--line);
  text-align: left;
}

.jz-docm .kv span:first-child {
  color: var(--mute);
}

.jz-docm .kv span:last-child {
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
}

/* Statement */
.jz-docm .logo {
  font-weight: 800;
  font-size: 20px;
  letter-spacing: -0.5px;
}

.jz-docm .logo b {
  color: var(--acc);
}

.jz-docm .stm {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  border-bottom: 2px solid var(--acc);
  padding-bottom: 14px;
}

.jz-docm .stm .right {
  text-align: right;
}

.jz-docm .stm .right span {
  color: var(--mute);
}

.jz-docm .period {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-wrap: wrap;
  margin: 14px 0 0;
}

.jz-docm .period label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--mute);
  margin-bottom: 4px;
}

.jz-docm input,
.jz-docm select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--bg);
  color: var(--ink);
  font: inherit;
}

.jz-docm input:focus-visible,
.jz-docm select:focus-visible {
  outline: 2px solid var(--acc);
  outline-offset: 1px;
}

.jz-docm .sum {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin: 16px 0;
}

.jz-docm .sum div {
  background: var(--bg);
  border-radius: 12px;
  padding: 12px;
}

.jz-docm .sum small {
  color: var(--mute);
  display: block;
}

.jz-docm .sum b {
  font-size: 17px;
}

.jz-docm .cr {
  color: var(--ok);
  font-weight: 600;
}

.jz-docm .db {
  color: var(--bad);
  font-weight: 600;
}

.jz-docm .tw {
  overflow-x: auto;
}

.jz-docm table {
  width: 100%;
  border-collapse: collapse;
  min-width: 560px;
}

.jz-docm th {
  font-size: 11.5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--mute);
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid var(--line);
}

.jz-docm td {
  padding: 11px 10px;
  border-bottom: 1px solid var(--line);
}

.jz-docm tr:last-child td {
  border-bottom: 0;
}

.jz-docm .r {
  text-align: right;
}

.jz-docm .empty {
  color: var(--mute);
  text-align: center;
  padding: 24px 0;
}

/* Statement as a standalone page */
.jz-docm.page {
  position: static;
  inset: auto;
  background: none;
  display: block;
  padding: 0;
  z-index: auto;
}

.jz-docm.page .box {
  max-width: none;
  max-height: none;
  overflow: visible;
  box-shadow: 0 1px 2px rgba(42, 30, 24, 0.04);
}

.jz-docm .pg-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.jz-docm .pg-head h1 {
  font-size: 26px;
  letter-spacing: -0.6px;
  margin: 6px 0 2px;
}

.jz-docm .pg-head p {
  color: var(--mute);
  margin: 0;
}

.jz-docm .back {
  color: var(--acc);
  font-weight: 600;
  text-decoration: none;
}

.jz-docm .back:hover {
  text-decoration: underline;
}

.jz-docm.page .period > div {
  min-width: 170px;
}

/* Withdraw */
.jz-docm .field {
  margin-bottom: 14px;
}

.jz-docm .field label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--mute);
  margin-bottom: 4px;
}

.jz-docm .field input[aria-invalid="true"] {
  border-color: var(--bad);
}

.jz-docm .money {
  position: relative;
}

.jz-docm .money span {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--mute);
  font-size: 13px;
  pointer-events: none;
}

.jz-docm .money input {
  padding-left: 46px;
  font-size: 18px;
  font-weight: 700;
}

.jz-docm .msg {
  font-size: 12.5px;
  margin-top: 6px;
  color: var(--mute);
}

.jz-docm .msg.bad {
  color: var(--bad);
  font-weight: 600;
}

.jz-docm .avail {
  background: var(--bg);
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.jz-docm .avail span {
  color: var(--mute);
}

.jz-docm .note {
  background: var(--warnbg);
  color: var(--warn);
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
  font-weight: 600;
}

.jz-docm .otp {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 8px 0 6px;
}

.jz-docm .otp input {
  width: 46px;
  height: 54px;
  padding: 0;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  border-radius: 12px;
}

.jz-docm .otp input[aria-invalid="true"] {
  border-color: var(--bad);
}

.jz-docm .center {
  text-align: center;
}

.jz-docm .link {
  border: 0;
  background: none;
  color: var(--acc);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.jz-docm .link:disabled {
  color: var(--mute);
  cursor: default;
}

@media (max-width: 760px) {
  .jz-docm .sum {
    grid-template-columns: 1fr 1fr;
  }

  .jz-docm .otp input {
    width: 40px;
    height: 48px;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  .jz-docm .print,
  .jz-docm .print * {
    visibility: visible;
  }

  .jz-docm {
    position: absolute;
    inset: 0;
    background: #fff;
    display: block;
    padding: 0;
  }

  .jz-docm .box {
    box-shadow: none;
    border: 0;
    max-height: none;
    overflow: visible;
  }

  .jz-docm .noprint {
    display: none !important;
  }
}
